const mobx = require("mobx");

type MakeObservableFn<T extends object> = (target: T) => T;

export const makeObservable: MakeObservableFn<any> =
  "makeObservable" in mobx ? mobx["makeObservable"] : (target) => target;
